import { render, staticRenderFns } from "./RecaptchaWidget.vue?vue&type=template&id=88250c94&scoped=true"
import script from "./RecaptchaWidget.vue?vue&type=script&lang=js"
export * from "./RecaptchaWidget.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaWidget.vue?vue&type=style&index=0&id=88250c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88250c94",
  null
  
)

export default component.exports